const initialState = {
  status: "invalid",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case "TASK_LOADING":
      return {
        ...state,
        status: "loading",
      };
    case "TASK_SUCCESS":
      return {
        ...state,
        status: "success",
        ...action
      };
    case "TASK_FAILURE":
      return {
        ...state,
        status: "failure",
      };
    default:
      return state;
  }
};